import { useCallback, useEffect, useState } from "react";
import { useLocation } from "@reach/router";
import { navigate } from "gatsby";
import { allBrochureContentGroupId } from "src/templates/RequestBrochure/RequestBrochureGroupPage";

export function useBrochureUrlFilter() {
  const location = useLocation();
  const paramName = "brochureGroup";

  const getInitialValue = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(paramName) || allBrochureContentGroupId;
  };

  const [selectedFilter, setSelectedFilter] =
    useState<string>(getInitialValue());

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.set(paramName, selectedFilter);

    const search = searchParams.toString();
    const query = search ? `?${search}` : "";

    navigate(location.pathname + query, { replace: true });
  }, [selectedFilter, paramName, location.pathname]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paramValue = searchParams.get(paramName);

    if (paramValue !== selectedFilter) {
      setSelectedFilter(paramValue || allBrochureContentGroupId);
    }
  }, [location.search, paramName]);

  const onBrochureFilterChange = useCallback((newGroupId: string) => {
    setSelectedFilter(newGroupId);
  }, []);

  return [selectedFilter, onBrochureFilterChange] as const;
}
